import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';
import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';
import { Sidebar2026 } from '../SchoolProgram2023/components';


const TeachersDay1to82026 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });
    const [config, setConfig] = useState({ base_image_url_2026: '' });
    useEffect(() => {
      fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
        .then(response => response.json())
        .then(data => setConfig(data))
        .catch(error => console.error('Error fetching config:', error));
    }, []);
    
    const p1 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay/1.webp`;
    const p2 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay/2.webp`;
    const p3 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay/3.webp`;
    const p4 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay/4.webp`;
    const p5 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay/5.webp`;
    const p6 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay/6.webp`;
    const p7 = `${config.base_image_url_2026}/home/events-activities/school-programs/TeachersDay/7.webp`;

    const photos = [
  
        {
            src: p1,
            source: p1,
            rows: 2,
            cols: 2,
        }, 
        {
            src: p2,
            source: p2,
            rows: 2,
            cols: 2,
        }, {
            src: p3,
            source: p3,
            rows: 2,
            cols: 2,
        }, {
            src: p4,
            source: p4,
            rows: 2,
            cols: 2,
        }, {
            src: p5,
            source: p5,
            rows: 2,
            cols: 2,
        }, {
            src: p6,
            source: p6,
            rows: 2,
            cols: 2,
        }, {
            src: p7,
            source: p7,
            rows: 2,
            cols: 2,
        }
 
    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                          
                            <Box >
                                <Typography variant='h4' align='center'>
                                Teacher’s Day
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                 Classes : 1 to 8      Date: 05.09.26
                                </Typography>

                                <br />
                                                    <Typography variant={'subtitle1'} align={'justify'}>
Teachers’ Day was celebrated with great enthusiasm and joy in our school to honour and
appreciate the dedication, guidance and invaluable contribution of our teachers. The celebration
was a beautiful blend of music, dance, drama and heartfelt expressions of gratitude.
                                                        <br></br>
The programme began with a student speaking about the significance of Teachers’ Day,
highlighting the importance of teachers’ role played in shaping the lives and future of their
students. This was followed by a special song presented by the students of Grade 3, dedicated
to all the teachers. Their melodious performance expressed the students’ love and gratitude.
Then students of Class 1 delighted the audience with a beautiful dance performance. Their
enthusiasm, energy, and charming presentation won the appreciation from everyone present
there.
                                                        <br></br>
The celebrations continued with an entertaining theatre performance by Classes 4 and 5. The
students enacted various classroom scenes, portraying familiar and amusing moments from
their school life. Their confident acting and timely sense of humour brought smiles and laughter
to the audience.
                                                        <br></br>
One of the highlights of the celebration was the fashion show combined with a skit, in which the
students enthusiastically and humorously enacted how teachers from various departments
behave and treat students in the classroom. The skit was hilarious and showcased the students’
unique talents. Overall, it was highly entertaining performance that transformed the atmosphere
making it cheerful and lively.
                                                        <br></br>
 The programme culminated in a grand dance finale, bringing together the spirit and excitement
of the celebration. Following the finale, Principal mam addressed the gathering and appreciated
the sincere efforts of the students and staff in making the celebration a memorable one. The
programme concluded with a heartfelt note of thanks, expressing gratitude to the Principal,
teachers, staff and everyone who contributed to the success of the event.
 <br></br>
 The Teachers’ Day celebration was a memorable occasion that beautifully reflected the strong
bond between teachers and students. It served as a heartfelt tribute to the teachers whose
constant encouragement, guidance and dedication continue to inspire and shape young minds.
<br></br>

                                                    </Typography>
                            </Box>
                             <Typography
                                                            variant={'h6'}
                                                            color={'primary'}
                                                            align={'center'}
                                                            fontWeight={'normal'}
                                                        ><br />
                                         “Teachers are the architects who help build the foundation of a better tomorrow.”
                                                            <br />
        
                                                        </Typography>
                             <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                    <Box marginBottom={4}>
                            <Sidebar2026/>
                        </Box> 
                        <Box marginBottom={4}>
                            <Archive2022/>
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default TeachersDay1to82026;
